import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
// Layout
import AdminLayout from './components/AdminLayout'
// Pages
import LoginPage from './pages/LoginPage'
import TwoFactorVerifyPage from './pages/TwoFactorVerifyPage'
import DashboardPage from './pages/DashboardPage'
import ProfilePage from './pages/ProfilePage'
import TenantsPage from './pages/TenantsPage'
import TenantDetailPage from './pages/TenantDetailPage'
import CouponsPage from './pages/CouponsPage'
import SettingsPage from './pages/SettingsPage'
import CompanyPage from './pages/CompanyPage'
import LegalPage from './pages/LegalPage'
// Nuove Pages
import PlansPage from './pages/PlansPage'
import LogsPage from './pages/LogsPage'
import SecurityDashboardPage from './pages/SecurityDashboardPage'
import AnnouncementsPage from './pages/AnnouncementsPage'
import TwoFactorPage from './pages/TwoFactorPage'
import StripePage from './pages/StripePage'
// Organizations - FASE 8
import OrganizationsPage from './pages/OrganizationsPage'
import OrganizationDetailPage from './pages/OrganizationDetailPage'
// Legal Documents - FASE 3
import LegalDocumentsPage, { DocumentForm } from './pages/LegalDocumentsPage'
import LegalSignaturesPage from './pages/LegalSignaturesPage'
import PublishDocumentPage from './pages/PublishDocumentPage'

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, twoFactorPending } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  // Se 2FA pending, redirect a verifica
  if (twoFactorPending) {
    return <Navigate to="/2fa-verify" replace />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }
  return children
}

// 2FA Route wrapper - accessibile solo con 2FA pending
const TwoFactorRoute = ({ children }) => {
  const { isAuthenticated, loading, twoFactorPending } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  // Se già autenticato, vai a dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  // Se non c'è 2FA pending, torna al login
  if (!twoFactorPending) {
    return <Navigate to="/login" replace />
  }

  return children
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* 2FA Verification route */}
      <Route
        path="/2fa-verify"
        element={
          <TwoFactorRoute>
            <TwoFactorVerifyPage />
          </TwoFactorRoute>
        }
      />

      {/* Protected admin routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="tenants" element={<TenantsPage />} />
        <Route path="tenants/:id" element={<TenantDetailPage />} />
        <Route path="coupons" element={<CouponsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="company" element={<CompanyPage />} />
        <Route path="legal" element={<LegalPage />} />
        {/* Nuove routes */}
        <Route path="plans" element={<PlansPage />} />
        <Route path="logs" element={<LogsPage />} />
        <Route path="security" element={<SecurityDashboardPage />} />
        <Route path="announcements" element={<AnnouncementsPage />} />
        <Route path="two-factor" element={<TwoFactorPage />} />
        <Route path="stripe" element={<StripePage />} />
        {/* Organizations - FASE 8 */}
        <Route path="organizations" element={<OrganizationsPage />} />
        <Route path="organizations/:id" element={<OrganizationDetailPage />} />
        {/* Legal Documents - FASE 3 */}
        <Route path="legal-documents" element={<LegalDocumentsPage />} />
        <Route path="legal-documents/new" element={<DocumentForm />} />
        <Route path="legal-documents/:id" element={<DocumentForm isEdit />} />
        <Route path="legal-documents/:id/edit" element={<DocumentForm isEdit />} />
        <Route path="legal-documents/:id/signatures" element={<LegalSignaturesPage />} />
        <Route path="legal-documents/:id/publish" element={<PublishDocumentPage />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

export default App
